// REL-F04 · FE mirror of the REL-11 loader per-row outcome (BE authority:
// channeling-backend/src/lib/release-loader.js). The dry-run check classifies
// every grid row into one of these `checkState` values; the loader preview
// renders each with a DotCell whose colour comes from the buckets below.
export const RELEASE_CHECK_STATE_INVALID = 'invalid' // scenario 1  — integrity error, BLOCKS the import
export const RELEASE_CHECK_STATE_ABSENT = 'absent' // scenario 2  — plate not in Inventory ("ASSENTE")
export const RELEASE_CHECK_STATE_IGNORED = 'ignored' // scenario 3  — non-idoneo / already-SI circuit car
export const RELEASE_CHECK_STATE_BLOCKED_NO_UNFLAG = 'blocked_no_unflag' // scenario 4.6 — circuit car + Flag NO, skipped
export const RELEASE_CHECK_STATE_BLOCKED_BLIND = 'blocked_blind' // REL-12 — obbligo acquisto, flag NO immutable, skipped
export const RELEASE_CHECK_STATE_KEPT_SI = 'kept_si' // scenario 4.1 — SI -> SI, no change
export const RELEASE_CHECK_STATE_KEPT_NO = 'kept_no' // scenario 4.2 — NO -> NO, no change
export const RELEASE_CHECK_STATE_SET_SI = 'set_si' // scenario 4.3 — NO/VUOTO -> SI
export const RELEASE_CHECK_STATE_SET_NO = 'set_no' // scenario 4.4 — SI/VUOTO -> NO

// Red — the whole import is refused on confirm while any of these is present.
export const RELEASE_CHECK_ERROR_STATES = [RELEASE_CHECK_STATE_INVALID]
// Yellow — the row is skipped (no write) but the user must be aware of it.
export const RELEASE_CHECK_WARNING_STATES = [
  RELEASE_CHECK_STATE_ABSENT,
  RELEASE_CHECK_STATE_BLOCKED_NO_UNFLAG,
  RELEASE_CHECK_STATE_BLOCKED_BLIND,
]
// Green — the row produces a flag write on confirm.
export const RELEASE_CHECK_UPDATE_STATES = [
  RELEASE_CHECK_STATE_SET_SI,
  RELEASE_CHECK_STATE_SET_NO,
]
// Grey — the row is fine but nothing changes.
export const RELEASE_CHECK_NEUTRAL_STATES = [
  RELEASE_CHECK_STATE_IGNORED,
  RELEASE_CHECK_STATE_KEPT_SI,
  RELEASE_CHECK_STATE_KEPT_NO,
]

export const RELEASE_CHECK_ALL_STATES = [
  ...RELEASE_CHECK_ERROR_STATES,
  ...RELEASE_CHECK_WARNING_STATES,
  ...RELEASE_CHECK_UPDATE_STATES,
  ...RELEASE_CHECK_NEUTRAL_STATES,
]

// L2 · Status column (OK / KO). A row is KO when it yields no usable flag
// outcome: a malformed tracciato row (invalid → "Ignorata…"), a plate absent
// from Inventory (absent → "Ignorata…"), a plate whose state is not eligible
// (ignored → "Ignora per stato non idoneo") or a mandatory-to-buy car, whose
// flag can never be written (blocked_blind → "Obbligo acquisto (immutabile)").
// A matched row that is deliberately left unchanged (kept_*) or skipped by 4.6
// stays OK — its detail lives in the "Verifica" column. There is no
// whole-import block anymore — KO is purely per-row.
export const RELEASE_ROW_KO_STATES = [
  RELEASE_CHECK_STATE_INVALID,
  RELEASE_CHECK_STATE_ABSENT,
  RELEASE_CHECK_STATE_IGNORED,
  RELEASE_CHECK_STATE_BLOCKED_BLIND,
]

export const releaseRowStatusOk = (state) =>
  !RELEASE_ROW_KO_STATES.includes(state)

// Map a checkState to a DotCell colour token.
export const releaseCheckStateColor = (state) => {
  if (RELEASE_CHECK_ERROR_STATES.includes(state)) {
    return 'error'
  }
  if (RELEASE_CHECK_WARNING_STATES.includes(state)) {
    return 'warning'
  }
  if (RELEASE_CHECK_UPDATE_STATES.includes(state)) {
    return 'primary'
  }
  return 'textSecondary'
}
